import React, { Component } from "react";
import { Checkbox } from "material-ui";
import { Typeahead } from "react-bootstrap-typeahead";
import Tooltip from "rc-tooltip";
import ActionInfo from "material-ui/svg-icons/action/info-outline";
import ValuePanel from "./ValuePanel";

import {
  text_definition,
  primaryColor,
  debounceEventHandler,
} from "../../utils/utility";

import map from "lodash/map";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import some from "lodash/some";
import filter from "lodash/filter";

class AutoMakePanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      indexKey: null,
      selectedVal: null,
      selectedStates: [],
      focusItemId: undefined,
    };
  }

  componentWillUnmount() {
    this.setState({
      indexKey: null,
      selectedVal: null,
      selectedStates: [],
    });
  }

  handleModelSelect(id, isChecked) {
    const model = find(this.props.models, m => {
      return m.id === id;
    });
    this.props.selectModel(model, isChecked);
  }
  render() {
    let displayModels;
    if (this.state.indexKey) {
      const makeName = this.state.selectedVal;
      displayModels = filter(this.props.models, m => {
        return m.label.split(" - ")[0] === makeName;
      });
    }
    const selectedMakeIds = map(this.props.selected_make, "id");
    return (
      <div style={{ display: "flex", flexGrow: "1" }}>
        <div
          key={"geo-state-node-contianer"}
          style={{ width: "300px" }}
          className="light-grey-border"
        >
          <div
            className="pt-20 ml-20 mr-20 mb-10 pb-10 light-grey-bottom-border"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>
              <strong>Auto Make</strong>
            </div>
            <div style={{ height: "24px" }}></div>
          </div>
          <div className="light-grey-bottom-border mb-10 pb-10 ml-20 mr-20 mt-20">
            <Checkbox
              label={"Select All"}
              labelStyle={{ fontSize: "16px" }}
              iconStyle={{ fill: "#A3A3A3", marginRight: "10px" }}
              checked={
                this.props.selected_make.length > 0 &&
                this.props.selected_make.length === this.props.makes.length
              }
              onCheck={(e, isInputChecked) => {
                this.props.selectAllAutoMakes(isInputChecked);
              }}
            />
          </div>
          <div
            style={{
              height: "390px",
              overflowY: "scroll",
            }}
          >
            {map(this.props.makes, data => {
              let clsName = " ml-10 mr-10";
              const showMark = some(this.props.selected_model, m => {
                return m.label.split(" - ")[0] === data.label;
              });
              return (
                <div
                  key={data.label + "_" + data.id}
                  style={{
                    color: "#017FB5",
                    cursor: "pointer",
                    display: "flex",
                  }}
                  className={clsName}
                  onClick={() => {
                    this.setState({
                      indexKey: data.id,
                      selectedVal: data.value,
                    });
                    //if (this.props.getCities) this.props.getCities(data.id);
                  }}
                >
                  <div
                    className="p-10 mr-10"
                    style={{
                      background:
                        this.state.indexKey === data.id ? "#F5F5F5" : "#FFF",
                      flexGrow: "1",
                      display: "flex",
                    }}
                  >
                    <Checkbox
                      label={""}
                      labelStyle={{ fontSize: "16px" }}
                      style={{ width: "10px" }}
                      iconStyle={{ fill: "#A3A3A3", marginRight: "10px" }}
                      checked={selectedMakeIds.indexOf(data.id) >= 0}
                      onCheck={(e, isInputChecked) => {
                        this.props.selectMake(data, isInputChecked);
                      }}
                    />
                    <div style={{ flexGrow: "1" }}>{data.label} </div>
                    <div
                      style={{
                        display:
                          showMark && selectedMakeIds.indexOf(data.id) < 0
                            ? "flex"
                            : "none",
                        paddingTop: "4px",
                      }}
                    >
                      <i className="icon-checkmark4 text-orange-400" />
                    </div>
                  </div>
                  <div className="tree-node-arrow-right"></div>
                </div>
              );
            })}
          </div>
        </div>
        {displayModels && (
          <div style={{ flexGrow: "1" }}>
            <ValuePanel
              key={this.state.selectedVal + "_values_panel"}
              displayData={displayModels}
              selected_segments={map(this.props.selected_model, "id")}
              title={"Model"}
              showFilter={true}
              onCheck={(id, isChecked) => {
                this.handleModelSelect(id, isChecked);
              }}
              granularity={this.props.granularity}
              disabledAll={selectedMakeIds.indexOf(this.state.indexKey) >= 0}
            />
          </div>
        )}
      </div>
    );
  }
}

export default AutoMakePanel;



// WEBPACK FOOTER //
// ./src/components/AudienceBuilder/AutoMakePanel.js